<template lang="html">
  <div class="popover-primary-content">
    <div class="popover-primary-body">
      <div class="chkbox-group">
        <p class="chkbox-group-title">{{$t('INDENT_SELECT_DOCK')}}</p>
        <CheckboxGroup v-model="selectedDock">
          <Checkbox
            v-for="dock in docks"
            :label="dock"
            :disabled="dock.done"
            :checked="dock.done"
            :key="dock.id">
            {{$depot.dock(dock.id).name}}
          </Checkbox>
        </CheckboxGroup>
      </div>
      <div class="submit-button">
        <button class="btn primary-button" @click="startLoading">
          {{$t('INDENT_SUBMIT')}}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {

  props: ['order', 'currentGate'],

  data() {
    return {
      selectedDock: [],
    };
  },

  computed: {

    docks() {
      if (this.order.docks) {
        const currentGate = this.currentGate;
        return this.order.docks.filter(dock =>
          dock.gate_id === currentGate.gate_id).filter(dock =>
          dock.loading_started_at === null).map((dock) => {
          const done = Boolean(dock.loading_started_at && dock.loading_ended_at);
          return { ...dock, done };
        });
      }
      return [];
    },
  },

  methods: {
    async startLoading() {
      const id = this.order.order_number;
      const docks = this.selectedDock.filter(dock => !dock.done);
      // debugger;
      const gateId = docks[0].gate_id;
      const dockIds = docks.map(dock => dock.id);
      const data = { unique_id: this.currentGate.unique_id, dock_ids: dockIds };
      try {
        const result = await this.$store.dispatch('order/startLoading', { id, data });
        console.log(result);
        if (result && result.error) {
          this.$error({ message: result.error });
        } else if (result.order_number) {
          this.selectedDock = [];
          this.$emit('done', 'startLoading');
          this.$success({ message: this.$t('INDENT_LOADING_START_SUCCESS_MSG', { order_number: result.order_number }) });
        }
      } catch (err) {
        // log error
      }
    },
  },

};
</script>
<style scoped lang="scss">
@import "~@common/styles-shipper/settings";
.popover{
  &-primary {
    &-sm{
    min-width: 300px;
    max-width: 500px;
  .popover-primary-body {
      height: 75px;
      overflow:auto;
      padding: 2px;
      .chkbox-group {
        margin: 20px 0 0 0;
      }
    }
    &-footer{
    .submit-button{
          margin: 10px 0 0 0;
        }
      }
    }
  }
}
.el-checkbox {
  width: 150px;
  margin: 5px;
}
</style>
